<template>
  <div class="text-center">
    <h1 class="text-2xl font-semibold text-gray-800">Offer</h1>
    <p class="text-xl text-gray-500 mb-4">Get exclusive offers</p>
  </div>
  <div
    class="bg-gradient-to-r from-orange-50 to-orange-100 border border-orange-100 rounded-lg p-4 mb-4 flex items-start"
  >
    <div class="mr-3 text-orange-500 text-xl">
      <img
        src="@/public/v1/icons/Percentage-Orange.png"
        alt="Percentage Icon"
        title="Percentage Icon"
        class="w-7 h-7 text-orange-500"
      />
    </div>
    <div>
      <p class="text-sm text-black font-semibold">
        Save {{ discount.join('') }} with {{ data.coupon_code }}
      </p>
      <p class="text-xs text-gray-500 mt-1">
        Min order ₹{{ data.minimum_order_value }} 
        <span v-if="data.scope && data.scope.toLowerCase() !== 'delivery'">| Min item ₹{{ data.minimum_item_value }}</span>
      </p>
    </div>
    <button
      class="ml-auto text-orange-600 text-md font-extrabold px-3 py-1 border-orange-100"
      @click="applyCoupon"
    >
      Apply
    </button>
  </div>
  <h3 v-if="data?.tnc?.length" class="text-sm font-semibold text-black mb-1">
    *Terms and Conditions
  </h3>
  <ul class="list-disc list-inside text-sm text-gray-600">
    <div v-for="(tnc, index) in data.tnc" :key="index">
      <li>{{ tnc }}</li>
    </div>
  </ul>
</template>

<script setup>
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';

const props = defineProps(["data"]);
const emits = defineEmits(["apply", "couponTC"]);
const discount = ref([]);
const cart = useCart();
const result = computed(() => cart.response?.data);
const error = computed(() => cart.response?.error);
const summary = computed(() =>
  error.value ? [] : result.value?.map((k) => k.summary).flat() || []
);
const deliveryCharge = computed(()=> summary.value.filter((k) => k.type.toLowerCase() === "delivery"))
const totalDeliveryCharge = deliveryCharge.value.reduce((sum, item) => sum + Number(item.total), 0)

const { gtag } = useGtag();
const auth = useAuth();
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated
  ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    }
  : {
      user_name: null,
      user_phone: null,
      user_email: null,
    };

if (props.data.offer_type.toLowerCase() === 'value') {
  if(props.data.scope === 'delivery'){
    discount.value.push('₹',Math.min(props.data.offer_value, totalDeliveryCharge));
  }else{
    discount.value.push('₹',props.data.offer_value);
  }
}
if (props.data.offer_type.toLowerCase() === 'percentage') {
  discount.value.push(props.data.offer_value, '%');
}
const applyCoupon = () => {
  emits("apply", props.data.coupon_code);
  
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: "Apply coupon Apply",
    [EventParameter.COUPON_CODE]: props.data.coupon_code?.toUpperCase(),
  });
};

function formatDate(dateStr) {
  try {
    const parts = dateStr.split("/");
    const date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}T23:59:00`);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return dateStr;
  }
}
</script>
